import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { ReactNode } from 'react';
import { iconForCondition } from 'types/condition.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { IForecastDayTab } from '../types.js';
import { createHeaderDetails } from './day-header.js';
import { getDayForecastSlug } from './day-query-param.js';

type IAccordionHeaderSmall = {
  day: IForecastDayTab;
  children?: ReactNode;
};

export const AccordionHeaderSmall = ({ day, children }: IAccordionHeaderSmall) => {
  const slug = getDayForecastSlug(new Date(day.date));
  const { condition, highTemp, lowTemp } = day;
  const { headerName, headerDate } = createHeaderDetails(day.date);
  const icon = iconForCondition(condition);
  const hasHighTemp = isNotNullOrUndefined(highTemp);
  const hasLowTemp = isNotNullOrUndefined(lowTemp);
  const hadAdditionalContent = hasHighTemp || hasLowTemp;
  const headerClassNames = classNames(`Accordion-header`, { 'u-flex': hadAdditionalContent });
  const iconClassNames = classNames('IconWithText--small', { 'IconWithText--vCenter ': !hadAdditionalContent });
  const dateClassNames = classNames('u-textRegular u-block u-textNoWrap', { 'u-mL-xs': !hadAdditionalContent });

  return (
    <>
      <div className={headerClassNames} data-slug={slug}>
        <IconWithText icon={icon} classes={iconClassNames}>
          <h4 className="Accordion-heading u-mT-0 u-mB-0">
            <span className="u-block">{headerName}</span>
            {headerDate && <span className={dateClassNames}>{headerDate}</span>}
          </h4>
        </IconWithText>

        {hadAdditionalContent && (
          <div className="Accordion-temps">
            {hasHighTemp && (
              <IconWithText icon="temp-high" classes="IconWithText--vCenter IconWithText--small u-mR-xs">
                <p className="u-mT-0 u-mB-0 u-textSemibold">{highTemp}°</p>
              </IconWithText>
            )}
            {hasLowTemp && (
              <IconWithText icon="temp-low" classes="IconWithText--vCenter IconWithText--small">
                <p className="u-mT-0 u-mB-0 u-textSemibold">{lowTemp}°</p>
              </IconWithText>
            )}
          </div>
        )}
      </div>
      {children}
    </>
  );
};
